// sidebar.js
import * as mutationTypes from "../mutation-types";
import { SIDEBAR_TAB_IDS } from "@/vue/features/anytime-consultation-sidebar/model/sidebarTabIds";

function initialState() {
  return {
    sidebarTabId: SIDEBAR_TAB_IDS.SIMILAR_SEARCH,  // 選択中のタブ
    sidebarWidthRank: 2,              // 現在のサイドバーの幅を表すRank
    showSearchConditionDialog: false, // 追加検索条件ダイアログの表示フラグ
    showOptionDialog: false,          // 管理者向けオプションダイアログの表示フラグ
    daytimeSidebarWidthRankByUser: {}, // 日中助産師: ユーザーIDごとのサイドバー幅Rank
  };
}

const state = initialState();

const getters = {
  sidebarTabId: (state) => state.sidebarTabId,

  sidebarWidthRank: (state) => state.sidebarWidthRank,
  daytimeSidebarWidthRankByUser: (state) => state.daytimeSidebarWidthRankByUser,
  sidebarWidth: (state) => {
    switch (state.sidebarWidthRank) {
    case 1:
      return 30;
    case 2:
      return Math.floor(document.body.clientWidth / 3);
    case 3:
      return Math.floor(document.body.clientWidth * 3 / 5);
    }
  },
  isSidebarWidthMin: (state) => state.sidebarWidthRank === 1,
  isSidebarWidthMax: (state) => state.sidebarWidthRank === 3,

  showSearchConditionDialog: (state) => state.showSearchConditionDialog,
  showOptionDialog: (state) => state.showOptionDialog,
};

const actions = {
  selectSidebarTabId({ commit }, tabId) {
    commit(mutationTypes.ASSIGN_SIDEBAR_TAB_ID, tabId);
    commit(mutationTypes.OPEN_SIDEBAR);
  },
  updateSidebarWidthRank({ commit }, newRank) {
    commit(mutationTypes.ASSIGN_SIDEBAR_WIDTH_RANK, newRank);
  },
  saveDaytimeSidebarWidthRankForUser({ commit }, { userId, rank }) {
    commit(mutationTypes.ASSIGN_DAYTIME_SIDEBAR_WIDTH_RANK_FOR_USER, { userId, rank });
  },
  openSearchConditionDialog({ commit }) {
    commit(mutationTypes.ASSIGN_SEARCH_CONDITION_DIALOG, true);
  },
  closeSearchConditionDialog({ commit }) {
    commit(mutationTypes.ASSIGN_SEARCH_CONDITION_DIALOG, false);
  },
  openOptionDialog({ commit }) {
    commit(mutationTypes.ASSIGN_OPTION_DIALOG, true);
  },
  closeOptionDialog({ commit }) {
    commit(mutationTypes.ASSIGN_OPTION_DIALOG, false);
  },

  resetSidebarState({ commit }) {
    commit(mutationTypes.RESET_SIDEBAR_STATE);
  }
};


const mutations = {
  [mutationTypes.ASSIGN_SIDEBAR_TAB_ID](state, tabId) {
    state.sidebarTabId = tabId;
  },

  [mutationTypes.ASSIGN_SIDEBAR_WIDTH_RANK](state, newRank) {
    state.sidebarWidthRank = newRank;
  },
  [mutationTypes.ASSIGN_DAYTIME_SIDEBAR_WIDTH_RANK_FOR_USER](state, { userId, rank }) {
    state.daytimeSidebarWidthRankByUser = { ...state.daytimeSidebarWidthRankByUser, [userId]: rank };
  },
  // サイドバーが閉じている場合のみ、サイドバーを開く
  [mutationTypes.OPEN_SIDEBAR](state) {
    if (state.sidebarWidthRank === 1) {
      state.sidebarWidthRank = 2;
    }
  },
  [mutationTypes.ASSIGN_SEARCH_CONDITION_DIALOG](state, show) {
    state.showSearchConditionDialog = show;
  },
  [mutationTypes.ASSIGN_OPTION_DIALOG](state, show) {
    state.showOptionDialog = show;
  },
  [mutationTypes.RESET_SIDEBAR_STATE](state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
